var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_14976)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0175,
    cy: 20.5103,
    rx: 21.0175,
    ry: 20.5103,
    transform: "matrix(0.990744 0.135746 -0.142683 0.989769 42.9531 37)",
    fill: "#0367E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_14976)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0175,
    cy: 20.5103,
    rx: 21.0175,
    ry: 20.5103,
    transform: "matrix(0.990744 0.135746 -0.142683 0.989769 42.9531 37)",
    fill: "#0367E7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.1848 59.482L64.4768 62.2623C65.1375 62.3529 65.1385 62.353 65.2327 61.706C65.305 61.2047 65.3431 60.6948 65.4593 60.2024C65.5755 59.7099 65.386 59.5852 64.9151 59.5225C60.5571 58.9417 56.2033 58.3385 51.8486 57.7418L44.5773 56.7456C46.2185 49.3929 53.7695 43.673 62.4482 44.9024C71.0862 46.1272 77.3447 54.074 75.8894 62.7844C74.5145 71.0252 66.634 76.7451 58.1263 75.6878C49.3549 74.5972 43.6628 66.9986 44.1848 59.482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14976",
    x: 0.520313,
    y: 0.352345,
    width: 120.659,
    height: 119.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14976"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14976",
    x: 0.520313,
    y: 0.352345,
    width: 120.659,
    height: 119.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14976"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBaseIcon);
export default __webpack_public_path__ + "static/media/SecondBaseIcon.72c68715e55f00d2dd5bd28c14d40441.svg";
export { ForwardRef as ReactComponent };